module.exports = __webpack_public_path__ + "static/media/howto.409eebd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/howto.png
// module id = 567
// module chunks = 0